import React from 'react';
import { config } from '@triare/auth-redux';
import Layout from '../../components/Layout';
import CreateAccountContent from '../../components/Pages/CreateAccount';

const { displayName } = config;

export default function CreateAccount(): React.ReactElement {
  document.title = `${displayName}: Create Account`;

  return (
    <Layout>
      <CreateAccountContent />
    </Layout>
  );
}
